export const L10N = {
  ACTION_REJOIN: { id: 'lisa.action.rejoin' },
  ACTION_RETURN_HOME: { id: 'lisa.action.return_home' },

  LABEL_HOW_WAS_CONVERSATION: { id: 'lisa.label.how_was_conversation' },
  LABEL_LEFT_CONVERSATION: { id: 'lisa.label.left_conversation' },
  LABEL_VERY_BAD: { id: 'lisa.label.very_bad' },
  LABEL_VERY_GOOD: { id: 'lisa.label.very_good' },
};
